import { gql } from 'src/__generated__'

export default gql(`
  mutation resolveFoodConflict($data: ResolveFoodConflictInput!) {
    resolveFoodConflict(data: $data) {
      id
    }
  }
`)
